// Module
var code = "<div class=\"socialbar__button socialbar__button--comments\" ng-hide=\"!commentsCount.amount && commentsCount.amount !== 0 || !commentsCount.show\" scroll-bottom> {{commentsCount.amount}} <i class=\"large primary icon comment\"></i> </div>";
// Exports
module.exports = code;